export const PREVIOUS_STEP = 'PREVIOUS_STEP';
export const NEXT_STEP = 'NEXT_STEP';
export const GO_TO_STEP = 'GO_TO_STEP';
